import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { setTwoFactorCode } from '../actions/localStates'

class TwoFactorPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          secondsLeft: 59
      };

      this.onTwoFactorCodeChanged = this.onTwoFactorCodeChanged.bind(this);

      this.loginConfirm = this.loginConfirm.bind(this);

      this.handle2FKeyUp = this.handle2FKeyUp.bind(this, 'twoFactorInput');
  }

  componentDidMount() {
      var element = document.getElementById("2f");
      if (element !== null) {
        element.focus();
      }
      
      document.addEventListener('keyup', this.handle2FKeyUp);

      this.timer = setInterval(() => {
          this.setState(prev => {
              if (prev.secondsLeft <= 1) {
                  clearInterval(this.timer);
                  this.props.cancelRequest()
                  return { secondsLeft: 0 };
              }

              return {
                  secondsLeft: prev.secondsLeft - 1
              };
          });
      }, 1000);
  }

  componentWillUnmount() {
      document.removeEventListener('keyup', this.handle2FKeyUp);
  }

  handle2FKeyUp(refName, e) {
      if (e.keyCode === 13 && refName === "twoFactorInput") {
          document.getElementById("submitPin").click();
          document.activeElement.blur();
      }
  }

  onTwoFactorCodeChanged (e) {
    this.props.actions.setTwoFactorCode(e.target.value)
  }

  loginConfirm () {
    this.props.loginUser2f();
  }

  cancelLogin2f () {
    this.props.cancelRequest()
  }

  render() {
    let isEnabled = this.props.login.twoFactorCode >= 4
    ? true
    : false

    if (this.props.login.imageFor2F !== null) {
      const qr = this.props.login.imageFor2F.trim();
      var qrToShow;
          qrToShow = qr.startsWith("data:")
              ? qr
              : `data:image/png;base64,${qr}`
    }

      const TOTAL_SECONDS = this.props.codeTtl;

      const radius = 24;
      const circumference = 2 * Math.PI * radius;

      const progress = this.state.secondsLeft / TOTAL_SECONDS;

      const dashOffset = circumference * (progress - 1);

      return (
          <div className='popup'>
              <div className={"popup_inner_user_token_pin"}>
                  <div className="col-12" style={{marginTop: "30px"}}>
                      <div>
                          <label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingTop: "0px", paddingBottom: "0px"}}>{i18next.t("twoFactorPageTitle")}</label>

                          {
                            this.props.login.inputTypeFor2F === "image"
                            ? <div style={{textAlign: "center"}}>
                                <img src={qrToShow} style={{
                                      width: "256px",
                                      height: "256px",
                                      display: "block",
                                      margin: "0 auto"
                                  }} alt="img" />
                                <label style={{fontSize: "14px"}}>{i18next.t("scanQrMessage")}</label>
                                <p></p>
                                <button id="submit2f" style={{float: "right", marginBottom: "30px"}} className="btn btn-info" onClick={this.cancelLogin2f.bind(this)}>{i18next.t("cancelLabel")}</button>
                              </div>
                            : <div className="col-12 input-group">
                                <input id="2f" className="form-control" placeholder={i18next.t("oneTimeCodeTitle")} value={this.props.login.twoFactorCode} type="text" onChange={this.onTwoFactorCodeChanged} />
                            </div>
                          }

                      </div>
                      <div style={{float: "right", marginRight: "15px"}}>
                        {
                          this.props.login.inputTypeFor2F === "image"
                          ? null
                          :<button className="btn btn-info" id="submitPin" style={{marginLeft: "5px", marginBottom: "30px"}} disabled={!isEnabled} onClick={this.loginConfirm}>{i18next.t("signInTitle")}</button>
                        }
                      </div>
                      
                  </div>
                  <div
                        style={{
                            position: "absolute",
                            left: "15px",
                            bottom: "15px"
                        }}
                        >
                        <svg width="60" height="60">
                            <circle
                                cx="30"
                                cy="30"
                                r={radius}
                                fill="none"
                                stroke="#ddd"
                                strokeWidth="4"
                            />

                            <circle
                                cx="30"
                                cy="30"
                                r={radius}
                                fill="none"
                                stroke="#17a2b8"
                                strokeWidth="4"
                                strokeLinecap="round"
                                transform="rotate(-90 30 30)"
                                strokeDasharray={circumference}
                                strokeDashoffset={dashOffset}
                                style={{
                                    transition: "stroke-dashoffset 0.1s linear"
                                }}
                            />

                            <text
                                x="30"
                                y="35"
                                textAnchor="middle"
                                fontSize="16"
                                fontWeight="bold"
                            >
                                {this.state.secondsLeft}
                            </text>
                        </svg>
                    </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        selectedClient: state.clientReducer,
        login: state.loginReducer,
        userReducer: state.userReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setTwoFactorCode
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorPopup);